// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { OrderSummaryDTO } from '@shared/models/dashboard/order-summary';

export enum OrderStanding {
  normal = 1,
  warning = 2,
  critical = 3,
  overdue = 4,
} // it seems enum does not ended with ';'

export const ORDER_STANDING_LABELS = {
  [OrderStanding.normal]: 'Normal',
  [OrderStanding.warning]: 'Warning',
  [OrderStanding.critical]: 'Critical',
  [OrderStanding.overdue]: 'Overdue',
};

export enum AssetStanding {
  pending = 1,
  scheduled = 2,
  collected = 3,
  processed = 4,
  delivered = 5,
}

export const ASSET_STANDING_LABELS = {
  [AssetStanding.pending]: 'Pending',
  [AssetStanding.scheduled]: 'Scheduled',
  [AssetStanding.collected]: 'Collected',
  [AssetStanding.processed]: 'Processed',
  [AssetStanding.delivered]: 'Delivered',
};

export const NOTIFICATION_ITEM_FIELDS = {
  id: 'id',
  generalInfo: 'generalInfo',
  customer: 'customer',
  asset: 'asset',
  jobRequest: 'jobRequest',
  date: 'date',
  event: 'event',
};

// fields started with lower case are not displayed.
export const HOTSPOT_FIELDS = {
  orderId: 'id',
  orderName: 'orderName',
  orderNumber: 'orderNumber',
  customerName:'customerName',
  customerId:'customerId',
  assets: 'Assets',
  scheduled: 'Scheduled',
  collected: 'Collected',
  processed: 'Processed',
  delivered: 'Delivered',
  dueDate: 'dueDate',
  details: 'details',
  notes: 'notes',
  statusSummaryString: 'statusSummaryString',
};

// Label for columns if different from HOTSPOT_FIELDS names.
export const HOTSPOT_COLUMN_LABELS = {
  orderName: 'Order',
  customerName:'Customer',
  dueDate: 'Due',
};

export const HOTSPOT_DETAILS_FIELDS = {
  assetId: 'aId',
  asset: 'Asset',
  jobRequestId: 'jId',
  jobRequest: 'Job request',
  jobSummary: '<CALENDAR>',
};
export const assetSummaryTestDto1: OrderSummaryDTO = {
  standing: 'all',
  normalCount: 1,
  warningCount: 1,
  criticalCount: 1,
  overdueCount: 1,
};

export const assetSummaryTestDto2: OrderSummaryDTO = {
  standing: 'pending',
  normalCount: 2,
  warningCount: 2,
  criticalCount: 2,
  overdueCount: 2,
};